import axios from '../axios'
import { TFunction } from 'i18next'
import { IUpdateCustomer } from '../../interfaces/i-api-customer'
import { logError } from '../../../shared'
import { getHeadersWithJwtToken } from '../../../auth/utils/auth-util'
import appConfig from '../../../app.config'

async function updateCustomerService(
	customerData: IUpdateCustomer,
	t: TFunction
) {
	if (customerData.mobilePhoneNumber) {
		customerData.mobilePhoneNumber =
			customerData.mobilePhoneNumber.replaceAll(' ', '')

		customerData.mobilePhoneNumber =
			customerData.mobilePhoneNumber.startsWith('+490')
				? customerData.mobilePhoneNumber.replace(/^(\+490)/, '+49')
				: customerData.mobilePhoneNumber
	}
	const response = await axios
		.post(
			`${appConfig.customerDataBaseUrl}/api/user/mobileapp/updatecustomer`,
			customerData,
			await getHeadersWithJwtToken()
		)
		.then((data) => {
			if (data.status === 200) {
				return
			}
			throw new Error(t('ErrorMsg'))
		})
		.catch((err) => {
			logError(err)
			throw new Error(t('ErrorMsg'))
		})
	return response
}

export default updateCustomerService
